import React, { Fragment } from 'react';
import { Row, Card, CardBody, CardTitle, Button } from 'reactstrap';
import { Colxx } from '../../common/CustomBootstrap';
import GlideComponent from '../../carousel/GlideComponent';
import IntlMessages from '../../../helpers/IntlMessages';

const BasicCarouselItem = ({ index, url, caption }) => {
  return (
    <div className="glide-item">
      <Card className="flex-row">
        <div className="w-100 position-relative">
          {url.slice(((url.lastIndexOf('.') - 1) >>> 0) + 2) !== 'mp4' ? (
            <iframe
              className="card-img-left"
              src={url
                .toString()
                .replace(
                  'https://www.youtube.com/watch?v=',
                  'https://www.youtube.com/embed/'
                )
                .replace(
                  'https://vimeo.com/',
                  'https://player.vimeo.com/video/'
                )}
              frameBorder={0}
              allow="autoplay; encrypted-media"
              allowFullScreen
              title={caption[index]}
            />
          ) : (
            <video
              aria-label
              controls
              poster
              className="card-img-left"
              src={url}
            ></video>
          )}
          <span
            className={`badge badge-pill badge-primary
                     position-absolute badge-top-left`}
          >
            {caption}
          </span>
        </div>
      </Card>
    </div>
  );
};

const Showing = ({ sildes }) => {
  const SildeItem = JSON.parse(sildes.text);
  //console.log(SildeItem.length);
  return (
    <Fragment>
      {SildeItem.length === 1 &&
        SildeItem.map((element1, index) => {
          return (
            <div key={index}>
              <BasicCarouselItem
                index={index}
                url={element1.url}
                caption={element1.caption}
              />
            </div>
          );
        })}
      {SildeItem.length > 1 && (
        <GlideComponent
          settings={{
            gap: 5,
            perView: 2,
            keyboard: false,
            // type: 'slider',
            rewind: false,
            // breakpoints: {
            //   600: { perView: 1 },
            //   1400: { perView: 2 },
            // },
          }}
        >
          {SildeItem.map((element1, index) => {
            return (
              <div key={index}>
                <BasicCarouselItem
                  index={index}
                  url={element1.url}
                  caption={element1.caption}
                />
              </div>
            );
          })}
        </GlideComponent>
      )}
    </Fragment>
  );
};
export default Showing;
